export default __webpack_public_path__ + "static/media/rider-3.c1a8ef4f.jpg";